import type { ReactNode } from 'react'
import { Phone, ListChecks, Sun, BarChart3 } from 'lucide-react'
import { cn } from '@/lib/cn'
import { relativeTime } from '@/lib/format'
import type { ActivityItem as ActivityItemType } from '@/types'

const iconByType: Record<ActivityItemType['type'], ReactNode> = {
  call: <Phone size={14} />,
  task: <ListChecks size={14} />,
  briefing: <Sun size={14} />,
  ads_sync: <BarChart3 size={14} />,
}

const colorByType: Record<ActivityItemType['type'], string> = {
  call: 'text-jarvis-blue',
  task: 'text-jarvis-amber',
  briefing: 'text-jarvis-cyan',
  ads_sync: 'text-jarvis-green',
}

interface ActivityItemProps {
  item: ActivityItemType
  action?: ReactNode
}

export function ActivityItem({ item, action }: ActivityItemProps) {
  return (
    <div className="flex gap-3 py-3 border-b border-jarvis-border/50 last:border-0">
      <div className="flex flex-col items-center pt-1">
        <span
          className={cn(
            'flex items-center justify-center w-7 h-7 rounded-full bg-jarvis-surface-2 border border-jarvis-border',
            colorByType[item.type],
          )}
        >
          {iconByType[item.type]}
        </span>
      </div>
      <div className="flex-1 min-w-0">
        <div className="flex items-baseline justify-between gap-3">
          <h4 className="text-sm font-medium text-jarvis-text truncate">{item.title}</h4>
          <span className="text-xs text-jarvis-muted whitespace-nowrap tabular">
            {relativeTime(item.timestamp)}
          </span>
        </div>
        <p className="text-sm text-jarvis-muted mt-0.5 line-clamp-2">{item.subtitle}</p>
        {action && <div className="mt-2">{action}</div>}
      </div>
    </div>
  )
}
